import { useCallback, useEffect, useMemo } from 'react';
import { useListingLibBulkActions } from 'framework-listing-lib/internal/Table/providers/ListingLibBulkActionsProvider';
export default function useRegisterNestedRow({
  childCrmObject,
  parentCrmObject
}) {
  const {
    handleRegisterChild,
    getIsSelected
  } = useListingLibBulkActions();
  useEffect(() => {
    if (childCrmObject) {
      handleRegisterChild(parentCrmObject, childCrmObject);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isSelected = useMemo(() => getIsSelected(childCrmObject ? childCrmObject.objectId : -1), [childCrmObject, getIsSelected]);
  const onSelectRow = useCallback((__selectedCrmObject, ___status) => {}, []);
  return {
    isSelected,
    /**
     * @deprecated
     */
    onSelectRow
  };
}